/**
 * Concorsando API
 * API per Concorsando
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SottoPercorsoVO from './SottoPercorsoVO';

/**
* The PercorsoVO model module.
* @module model/PercorsoVO
* @version 2.0.0
*/
export default class PercorsoVO {
    /**
    * Constructs a new <code>PercorsoVO</code>.
    * @alias module:model/PercorsoVO
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>PercorsoVO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/PercorsoVO} obj Optional instance to populate.
    * @return {module:model/PercorsoVO} The populated <code>PercorsoVO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PercorsoVO();
                        
            
            if (data.hasOwnProperty('id_argomento')) {
                obj['id_argomento'] = ApiClient.convertToType(data['id_argomento'], 'String');
            }
            if (data.hasOwnProperty('argomento')) {
                obj['argomento'] = ApiClient.convertToType(data['argomento'], 'String');
            }
            if (data.hasOwnProperty('premium')) {
                obj['premium'] = ApiClient.convertToType(data['premium'], 'Boolean');
            }
            if (data.hasOwnProperty('data_ultimo_aggiornamento')) {
                obj['data_ultimo_aggiornamento'] = ApiClient.convertToType(data['data_ultimo_aggiornamento'], 'Date');
            }
            if (data.hasOwnProperty('stato')) {
                obj['stato'] = ApiClient.convertToType(data['stato'], 'Number');
            }
            if (data.hasOwnProperty('url_domande')) {
                obj['url_domande'] = ApiClient.convertToType(data['url_domande'], 'String');
            }
            if (data.hasOwnProperty('url_immagini')) {
                obj['url_immagini'] = ApiClient.convertToType(data['url_immagini'], 'String');
            }
            if (data.hasOwnProperty('dimensione_zip')) {
                obj['dimensione_zip'] = ApiClient.convertToType(data['dimensione_zip'], 'Number');
            }
            if (data.hasOwnProperty('sotto_percorsi')) {
                obj['sotto_percorsi'] = ApiClient.convertToType(data['sotto_percorsi'], {'String': SottoPercorsoVO});
            }
        }
        return obj;
    }

    /**
    * @member {String} id_argomento
    */
    'id_argomento' = undefined;
    /**
    * @member {String} argomento
    */
    'argomento' = undefined;
    /**
    * @member {Boolean} premium
    */
    'premium' = undefined;
    /**
    * @member {Date} data_ultimo_aggiornamento
    */
    'data_ultimo_aggiornamento' = undefined;
    /**
    * @member {Number} stato
    */
    'stato' = undefined;
    /**
    * @member {String} url_domande
    */
    'url_domande' = undefined;
    /**
    * @member {String} url_immagini
    */
    'url_immagini' = undefined;
    /**
    * @member {Number} dimensione_zip
    */
    'dimensione_zip' = undefined;
    /**
    * @member {Object.<String, module:model/SottoPercorsoVO>} sotto_percorsi
    */
    'sotto_percorsi' = undefined;




}
